import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./logout.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./logout.component.scss?ngResource";
import { Component } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { LocalStorageEnum } from "../../services/storage/local-storage-constants";
import { LocalStorageService } from "../../services/storage/local-storage.service";
let LogoutComponent = class LogoutComponent {
    authService;
    localStorage;
    constructor(authService, localStorage) {
        this.authService = authService;
        this.localStorage = localStorage;
    }
    ngOnInit() {
        this.localStorage.remove(LocalStorageEnum.Login);
        this.authService.unAuthenticate();
    }
    static ctorParameters = () => [
        { type: AuthService },
        { type: LocalStorageService }
    ];
};
LogoutComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-logout",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], LogoutComponent);
export { LogoutComponent };
